/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AreaOfCompetitionTypeBaseModelIEnumerableResponseWrapper } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class AocTypes<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags PageantAvailableEvent
   * @name GetAreaOfCompetitionTypes
   * @request GET:/AocTypes
   */
  getAreaOfCompetitionTypes = (params: RequestParams = {}) =>
    this.request<AreaOfCompetitionTypeBaseModelIEnumerableResponseWrapper, any>({
      path: `/AocTypes`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
